import { atom } from "jotai";

export const navActiveOverrideAtom = atom<string | null>(null);
